var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndeterminateSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 8.33333H11.6667V6.66667H3.33333V8.33333ZM1.66667 15C1.20833 15 0.815833 14.8369 0.489167 14.5108C0.163055 14.1842 0 13.7917 0 13.3333V1.66667C0 1.20833 0.163055 0.815833 0.489167 0.489167C0.815833 0.163055 1.20833 0 1.66667 0H13.3333C13.7917 0 14.1842 0.163055 14.5108 0.489167C14.8369 0.815833 15 1.20833 15 1.66667V13.3333C15 13.7917 14.8369 14.1842 14.5108 14.5108C14.1842 14.8369 13.7917 15 13.3333 15H1.66667Z",
    fill: "#0064FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndeterminateSmall);
export default __webpack_public_path__ + "static/media/IndeterminateSmall.9586db5c4ef06455a5a5c0ee63b8e72c.svg";
export { ForwardRef as ReactComponent };